module.exports = __webpack_public_path__ + "img/跳转身份证链接.4c78bea8.png";